import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

type CommentContextType = {
    editingComment: string;
    setEditingComment: (id: string) => void;
};

const CommentsContext = createContext<CommentContextType>({ editingComment: '', setEditingComment: () => {} });

type CommentsAddonProviderProps = {
    children: ReactNode | ReactNode[];
};

export function CommentsAddonProvider({ children }: CommentsAddonProviderProps): JSX.Element {
    const [editingComment, setEditingComment] = useState('');

    const value = useMemo(() => ({ editingComment, setEditingComment }), [editingComment]);

    return <CommentsContext.Provider value={value}>{children}</CommentsContext.Provider>;
}

export function useCommentsAddon(): CommentContextType {
    const context = useContext(CommentsContext);
    if (context === undefined) {
        throw new Error('useCommentsAddon must be used within CommentsAddonProvider');
    }
    return context;
}
